import { useQuery, UseQueryOptions, UseQueryResult } from '@tanstack/react-query';
import axiosAuth from '../axiosAuth';
import { COMMUNITY_API } from './apiRoutes';

interface UseGetToleranceReportProps {
  communityId: string;
  filter?: {
    budgetYear?: string;
    postingYear?: string;
  };
  queryParams?: Omit<UseQueryOptions, 'queryKey'>;
}

const getToleranceReport = async (communityId: string, filter?: {
  budgetYear?: string;
  postingYear?: string;
}) => {
  return await axiosAuth.get(`${COMMUNITY_API}/${communityId}/reports/tolerance-360?${new URLSearchParams(filter).toString()}`);
};

const useGetToleranceReport = ({
  communityId,
  filter,
  queryParams,
}: UseGetToleranceReportProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ['tolerance-report', communityId],
    queryFn: () => getToleranceReport(communityId, filter),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useGetToleranceReport;
